import { Component } from '@angular/core';
// import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
// import { Observable } from 'rxjs';

@Component({
  selector: 'app-no-acess',
  templateUrl: './no-acess.component.html',
  styleUrls: ['./no-acess.component.css']
})
export class NoAcessComponent  {
  
}
